import { memo } from 'react';
import { Divider, Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { FormikErrors, FormikTouched } from 'formik';
import ConsulateList from 'shell/components/shared/consulate-list';
import { AccordionIdentityCard as AccordionIdentityCardVM } from 'shell/components/shared/sipo-person-form/new-person';

interface IdentityCardProps {
  disabled?: boolean;
  values?: AccordionIdentityCardVM;
  onChange: (
    key: keyof AccordionIdentityCardVM,
    value: AccordionIdentityCardVM[keyof AccordionIdentityCardVM]
  ) => void;
  isEditMode?: boolean;
  errors?: FormikErrors<AccordionIdentityCardVM>;
  touched?: FormikTouched<AccordionIdentityCardVM>;
}

const ConsulateReleaseComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
  errors,
  touched,
}: IdentityCardProps): React.ReactElement => {
  const onChangeConsulate = useEventCallback((event: SelectChangeEvent<string>) =>
    onChange('consulateCode', event.target.value)
  );

  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Consolato rilascio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={6}>
        <ConsulateList
          value={values?.consulateCode || ''}
          onChange={onChangeConsulate}
          label="Consolato *"
          id="consulate-code"
          error={touched?.consulateCode && Boolean(errors?.consulateCode)}
          disabled={isEditMode ? false : disabled}
        />
      </Grid>
    </Grid>
  );
};

ConsulateReleaseComponent.displayName = 'Consulate Release component';

const ConsulateRelease = memo(ConsulateReleaseComponent);

export default ConsulateRelease;
